import styled from "styled-components";

const Moldura = styled.div<{ $sistema: "android" | "iphone" }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px;
  border-radius: 24px;
  background: ${({ $sistema }) =>
    $sistema === "iphone" ? "linear-gradient(160deg, #4b6584 0%, #2d3e50 100%)" : "linear-gradient(160deg, #1f2a44 0%, #0f1626 100%)"};

  .rotulo {
    font-size: 11px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.72);
    font-weight: 600;
  }
`;

const Android = styled.div`
  display: grid;
  grid-template-columns: 20px 1fr;
  gap: 4px 10px;
  padding: 12px 14px;
  border-radius: 18px;
  background: #f1f3f4;
  color: #1f1f1f;
  font-family: Roboto, system-ui, sans-serif;

  img {
    width: 20px;
    height: 20px;
    border-radius: 50%;
  }
  .app {
    font-size: 12px;
    color: #5f6368;
    align-self: center;
  }
  .titulo {
    grid-column: 2;
    font-size: 14px;
    font-weight: 600;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .texto {
    grid-column: 2;
    font-size: 13px;
    line-height: 18px;
    color: #3c4043;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

const Iphone = styled.div`
  display: grid;
  grid-template-columns: 38px 1fr auto;
  gap: 0 10px;
  padding: 12px;
  border-radius: 22px;
  background: rgba(245, 245, 247, 0.92);
  color: #000;
  font-family: -apple-system, "SF Pro Text", system-ui, sans-serif;

  img {
    grid-row: span 2;
    width: 38px;
    height: 38px;
    border-radius: 9px;
    background: #fff;
  }
  .titulo {
    font-size: 14px;
    font-weight: 600;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .hora {
    font-size: 12px;
    color: #8e8e93;
  }
  .texto {
    grid-column: 2 / span 2;
    font-size: 14px;
    line-height: 19px;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

type Props = { titulo: string; texto: string };

/**
 * Aproximação de como a notificação aparece: o Android corta o texto em duas
 * linhas na tela de bloqueio; o iPhone mostra até quatro. A aparência final
 * depende do sistema e das configurações do aparelho.
 */
export const PreviaDaNotificacao = ({ titulo, texto }: Props) => {
  const tituloVisivel = titulo.trim() || "Título da notificação";
  const textoVisivel = texto.trim() || "A mensagem aparece aqui.";
  return (
    <div style={{ display: "grid", gap: 12 }}>
      <Moldura $sistema="android" aria-label="Prévia no Android">
        <span className="rotulo">Android</span>
        <Android>
          <img src="/g-192.png" alt="" />
          <span className="app">GeoRanking · agora</span>
          <span className="titulo">{tituloVisivel}</span>
          <span className="texto">{textoVisivel}</span>
        </Android>
      </Moldura>
      <Moldura $sistema="iphone" aria-label="Prévia no iPhone">
        <span className="rotulo">iPhone (app na Tela de Início)</span>
        <Iphone>
          <img src="/g-192.png" alt="" />
          <span className="titulo">{tituloVisivel}</span>
          <span className="hora">agora</span>
          <span className="texto">{textoVisivel}</span>
        </Iphone>
      </Moldura>
    </div>
  );
};
